import { I as IcAdd } from './react/ic_add.mjs';
import { I as IcAddFill } from './react/ic_add_fill.mjs';
import { I as IcAlarm } from './react/ic_alarm.mjs';
import { I as IcAnchoringdownFill } from './react/ic_anchoringdown_fill.mjs';
import { I as IcAnchoringupFill } from './react/ic_anchoringup_fill.mjs';
import { I as IcArea } from './react/ic_area.mjs';
import { I as IcArrowback } from './react/ic_arrowback.mjs';
import { I as IcArrowbackFill } from './react/ic_arrowback_fill.mjs';
import { I as IcArrowdropFill } from './react/ic_arrowdrop_fill.mjs';
import { I as IcArrowdropFillNomargin } from './react/ic_arrowdrop_fill_nomargin.mjs';
import { I as IcArrowforwardFill } from './react/ic_arrowforward_fill.mjs';
import { I as IcArrowforwardFillNomargin } from './react/ic_arrowforward_fill_nomargin.mjs';
import { I as IcArrowleftFill } from './react/ic_arrowleft_fill.mjs';
import { I as IcArrowleftFillNomargin } from './react/ic_arrowleft_fill_nomargin.mjs';
import { I as IcArrowlessFill } from './react/ic_arrowless_fill.mjs';
import { I as IcArrowmoreFill } from './react/ic_arrowmore_fill.mjs';
import { I as IcArrowoneway } from './react/ic_arrowoneway.mjs';
import { I as IcArrowrightFill } from './react/ic_arrowright_fill.mjs';
import { I as IcArrowrightFillNomargin } from './react/ic_arrowright_fill_nomargin.mjs';
import { I as IcArrowroundtrip } from './react/ic_arrowroundtrip.mjs';
import { I as IcArrowupFill } from './react/ic_arrowup_fill.mjs';
import { I as IcArrowupFillNomargin } from './react/ic_arrowup_fill_nomargin.mjs';
import { I as IcAutorefund } from './react/ic_autorefund.mjs';
import { I as IcBaggage } from './react/ic_baggage.mjs';
import { I as IcBed } from './react/ic_bed.mjs';
import { I as IcBrandLogo } from './react/ic_brand_logo.mjs';
import { I as IcBus } from './react/ic_bus.mjs';
import { I as IcBusFill } from './react/ic_bus_fill.mjs';
import { I as IcCalendar } from './react/ic_calendar.mjs';
import { I as IcCalendarcheck } from './react/ic_calendarcheck.mjs';
import { I as IcCalendarcheckFill } from './react/ic_calendarcheck_fill.mjs';
import { I as IcCamera } from './react/ic_camera.mjs';
import { I as IcCart } from './react/ic_cart.mjs';
import { I as IcCartH72 } from './react/ic_cart_h72.mjs';
import { I as IcCategory } from './react/ic_category.mjs';
import { I as IcCategoryFill } from './react/ic_category_fill.mjs';
import { I as IcChatbot } from './react/ic_chatbot.mjs';
import { I as IcChatbotH32 } from './react/ic_chatbot_h32.mjs';
import { I as IcClock } from './react/ic_clock.mjs';
import { I as IcClose } from './react/ic_close.mjs';
import { I as IcConvenience } from './react/ic_convenience.mjs';
import { I as IcCopy } from './react/ic_copy.mjs';
import { I as IcCoupon } from './react/ic_coupon.mjs';
import { I as IcCouponFill } from './react/ic_coupon_fill.mjs';
import { I as IcCouponH72 } from './react/ic_coupon_h72.mjs';
import { I as IcDayuse } from './react/ic_dayuse.mjs';
import { I as IcDelete } from './react/ic_delete.mjs';
import { I as IcDeleteFill } from './react/ic_delete_fill.mjs';
import { I as IcDone } from './react/ic_done.mjs';
import { I as IcDoneFill } from './react/ic_done_fill.mjs';
import { I as IcEdit } from './react/ic_edit.mjs';
import { I as IcEditFill } from './react/ic_edit_fill.mjs';
import { I as IcEnter } from './react/ic_enter.mjs';
import { I as IcError } from './react/ic_error.mjs';
import { I as IcErrorFill } from './react/ic_error_fill.mjs';
import { I as IcErrorH72 } from './react/ic_error_h72.mjs';
import { I as IcFace } from './react/ic_face.mjs';
import { I as IcFailoverH72 } from './react/ic_failover_h72.mjs';
import { I as IcFaq } from './react/ic_faq.mjs';
import { I as IcFaqH32 } from './react/ic_faq_h32.mjs';
import { I as IcFavorite } from './react/ic_favorite.mjs';
import { I as IcFavoriteFill } from './react/ic_favorite_fill.mjs';
import { I as IcFavoriteFillAccentshadow } from './react/ic_favorite_fill_accentshadow.mjs';
import { I as IcFavoriteFillOpblack30shadow } from './react/ic_favorite_fill_opblack30shadow.mjs';
import { I as IcFavoriteH72 } from './react/ic_favorite_h72.mjs';
import { I as IcFilter } from './react/ic_filter.mjs';
import { I as IcFlight } from './react/ic_flight.mjs';
import { I as IcFlightFill } from './react/ic_flight_fill.mjs';
import { I as IcGift } from './react/ic_gift.mjs';
import { I as IcGiftFill } from './react/ic_gift_fill.mjs';
import { I as IcHelp } from './react/ic_help.mjs';
import { I as IcHelpFill } from './react/ic_help_fill.mjs';
import { I as IcHelpdesk } from './react/ic_helpdesk.mjs';
import { I as IcHelpdeskH32 } from './react/ic_helpdesk_h32.mjs';
import { I as IcHome } from './react/ic_home.mjs';
import { I as IcHomeFill } from './react/ic_home_fill.mjs';
import { I as IcInfo } from './react/ic_info.mjs';
import { I as IcInfoFill } from './react/ic_info_fill.mjs';
import { I as IcInsertphoto } from './react/ic_insertphoto.mjs';
import { I as IcKrwFill } from './react/ic_krw_fill.mjs';
import { I as IcLandmark } from './react/ic_landmark.mjs';
import { I as IcLeisure } from './react/ic_leisure.mjs';
import { I as IcLeisureFill } from './react/ic_leisure_fill.mjs';
import { I as IcList } from './react/ic_list.mjs';
import { I as IcListDot } from './react/ic_list_dot.mjs';
import { I as IcListH72 } from './react/ic_list_h72.mjs';
import { I as IcLocation } from './react/ic_location.mjs';
import { I as IcLocationFill } from './react/ic_location_fill.mjs';
import { I as IcLockerFill } from './react/ic_locker_fill.mjs';
import { I as IcLogout } from './react/ic_logout.mjs';
import { I as IcMail } from './react/ic_mail.mjs';
import { I as IcMap } from './react/ic_map.mjs';
import { I as IcMaximizeFill } from './react/ic_maximize_fill.mjs';
import { I as IcMenu } from './react/ic_menu.mjs';
import { I as IcMenuFill } from './react/ic_menu_fill.mjs';
import { I as IcMic } from './react/ic_mic.mjs';
import { I as IcMinimizeFill } from './react/ic_minimize_fill.mjs';
import { I as IcMorehoriz } from './react/ic_morehoriz.mjs';
import { I as IcMorevert } from './react/ic_morevert.mjs';
import { I as IcMy } from './react/ic_my.mjs';
import { I as IcMyFill } from './react/ic_my_fill.mjs';
import { I as IcMylocation } from './react/ic_mylocation.mjs';
import { I as IcNearme } from './react/ic_nearme.mjs';
import { I as IcNearmeFill } from './react/ic_nearme_fill.mjs';
import { I as IcNearmecircleFill } from './react/ic_nearmecircle_fill.mjs';
import { I as IcNearmehelp } from './react/ic_nearmehelp.mjs';
import { I as IcNeutralFill } from './react/ic_neutral_fill.mjs';
import { I as IcNeutralFillNomargin } from './react/ic_neutral_fill_nomargin.mjs';
import { I as IcNote } from './react/ic_note.mjs';
import { I as IcNotice } from './react/ic_notice.mjs';
import { I as IcNoticeH32 } from './react/ic_notice_h32.mjs';
import { I as IcNotification } from './react/ic_notification.mjs';
import { I as IcNotificationFill } from './react/ic_notification_fill.mjs';
import { I as IcNotificationH72 } from './react/ic_notification_h72.mjs';
import { I as IcParking } from './react/ic_parking.mjs';
import { I as IcPause } from './react/ic_pause.mjs';
import { I as IcPauseFill } from './react/ic_pause_fill.mjs';
import { I as IcPauseFillWhiteshadow } from './react/ic_pause_fill_whiteshadow.mjs';
import { I as IcPhone } from './react/ic_phone.mjs';
import { I as IcPlay } from './react/ic_play.mjs';
import { I as IcPlayFill } from './react/ic_play_fill.mjs';
import { I as IcPlayFillWhiteshadow } from './react/ic_play_fill_whiteshadow.mjs';
import { I as IcPoint } from './react/ic_point.mjs';
import { I as IcProperty } from './react/ic_property.mjs';
import { I as IcQr } from './react/ic_qr.mjs';
import { I as IcRefresh } from './react/ic_refresh.mjs';
import { I as IcRegistration } from './react/ic_registration.mjs';
import { I as IcRemove } from './react/ic_remove.mjs';
import { I as IcRemoveFill } from './react/ic_remove_fill.mjs';
import { I as IcReview } from './react/ic_review.mjs';
import { I as IcReviewH72 } from './react/ic_review_h72.mjs';
import { I as IcSave } from './react/ic_save.mjs';
import { I as IcSearch } from './react/ic_search.mjs';
import { I as IcSearchFill } from './react/ic_search_fill.mjs';
import { I as IcSearchH72 } from './react/ic_search_h72.mjs';
import { I as IcSeat } from './react/ic_seat.mjs';
import { I as IcSetting } from './react/ic_setting.mjs';
import { I as IcShare } from './react/ic_share.mjs';
import { I as IcSmokefree } from './react/ic_smokefree.mjs';
import { I as IcSnsFacebook } from './react/ic_sns_facebook.mjs';
import { I as IcSnsInstagram } from './react/ic_sns_instagram.mjs';
import { I as IcSnsNaverblog } from './react/ic_sns_naverblog.mjs';
import { I as IcSnsNaverpost } from './react/ic_sns_naverpost.mjs';
import { I as IcSnsYoutube } from './react/ic_sns_youtube.mjs';
import { I as IcSorting } from './react/ic_sorting.mjs';
import { I as IcStar } from './react/ic_star.mjs';
import { I as IcStarFill } from './react/ic_star_fill.mjs';
import { I as IcSubdirectory } from './react/ic_subdirectory.mjs';
import { I as IcSubway } from './react/ic_subway.mjs';
import { I as IcSubwayFill } from './react/ic_subway_fill.mjs';
import { I as IcSwitchairplane } from './react/ic_switchairplane.mjs';
import { I as IcTicket } from './react/ic_ticket.mjs';
import { I as IcTicketFill } from './react/ic_ticket_fill.mjs';
import { I as IcTrain } from './react/ic_train.mjs';
import { I as IcTrainFill } from './react/ic_train_fill.mjs';
import { I as IcTrashcan } from './react/ic_trashcan.mjs';
import { I as IcVacation } from './react/ic_vacation.mjs';
import { I as IcVisibilityoff } from './react/ic_visibilityoff.mjs';
import { I as IcVisibilityon } from './react/ic_visibilityon.mjs';
import { I as IcVolumeoff } from './react/ic_volumeoff.mjs';
import { I as IcVolumeoffFill } from './react/ic_volumeoff_fill.mjs';
import { I as IcVolumeoffFillWhiteshadow } from './react/ic_volumeoff_fill_whiteshadow.mjs';
import { I as IcVolumeon } from './react/ic_volumeon.mjs';
import { I as IcVolumeonFill } from './react/ic_volumeon_fill.mjs';
import { I as IcVr } from './react/ic_vr.mjs';
import { I as IcYcoin } from './react/ic_ycoin.mjs';
export { c as createNolIcon, i as isNolIcon } from './utils/index.js.mjs';
import 'react';

const icons = { 'ic_add': IcAdd,
'ic_add_fill': IcAddFill,
'ic_alarm': IcAlarm,
'ic_anchoringdown_fill': IcAnchoringdownFill,
'ic_anchoringup_fill': IcAnchoringupFill,
'ic_area': IcArea,
'ic_arrowback': IcArrowback,
'ic_arrowback_fill': IcArrowbackFill,
'ic_arrowdrop_fill': IcArrowdropFill,
'ic_arrowdrop_fill_nomargin': IcArrowdropFillNomargin,
'ic_arrowforward_fill': IcArrowforwardFill,
'ic_arrowforward_fill_nomargin': IcArrowforwardFillNomargin,
'ic_arrowleft_fill': IcArrowleftFill,
'ic_arrowleft_fill_nomargin': IcArrowleftFillNomargin,
'ic_arrowless_fill': IcArrowlessFill,
'ic_arrowmore_fill': IcArrowmoreFill,
'ic_arrowoneway': IcArrowoneway,
'ic_arrowright_fill': IcArrowrightFill,
'ic_arrowright_fill_nomargin': IcArrowrightFillNomargin,
'ic_arrowroundtrip': IcArrowroundtrip,
'ic_arrowup_fill': IcArrowupFill,
'ic_arrowup_fill_nomargin': IcArrowupFillNomargin,
'ic_autorefund': IcAutorefund,
'ic_baggage': IcBaggage,
'ic_bed': IcBed,
'ic_brand_logo': IcBrandLogo,
'ic_bus': IcBus,
'ic_bus_fill': IcBusFill,
'ic_calendar': IcCalendar,
'ic_calendarcheck': IcCalendarcheck,
'ic_calendarcheck_fill': IcCalendarcheckFill,
'ic_camera': IcCamera,
'ic_cart': IcCart,
'ic_cart_h72': IcCartH72,
'ic_category': IcCategory,
'ic_category_fill': IcCategoryFill,
'ic_chatbot': IcChatbot,
'ic_chatbot_h32': IcChatbotH32,
'ic_clock': IcClock,
'ic_close': IcClose,
'ic_convenience': IcConvenience,
'ic_copy': IcCopy,
'ic_coupon': IcCoupon,
'ic_coupon_fill': IcCouponFill,
'ic_coupon_h72': IcCouponH72,
'ic_dayuse': IcDayuse,
'ic_delete': IcDelete,
'ic_delete_fill': IcDeleteFill,
'ic_done': IcDone,
'ic_done_fill': IcDoneFill,
'ic_edit': IcEdit,
'ic_edit_fill': IcEditFill,
'ic_enter': IcEnter,
'ic_error': IcError,
'ic_error_fill': IcErrorFill,
'ic_error_h72': IcErrorH72,
'ic_face': IcFace,
'ic_failover_h72': IcFailoverH72,
'ic_faq': IcFaq,
'ic_faq_h32': IcFaqH32,
'ic_favorite': IcFavorite,
'ic_favorite_fill': IcFavoriteFill,
'ic_favorite_fill_accentshadow': IcFavoriteFillAccentshadow,
'ic_favorite_fill_opblack30shadow': IcFavoriteFillOpblack30shadow,
'ic_favorite_h72': IcFavoriteH72,
'ic_filter': IcFilter,
'ic_flight': IcFlight,
'ic_flight_fill': IcFlightFill,
'ic_gift': IcGift,
'ic_gift_fill': IcGiftFill,
'ic_help': IcHelp,
'ic_help_fill': IcHelpFill,
'ic_helpdesk': IcHelpdesk,
'ic_helpdesk_h32': IcHelpdeskH32,
'ic_home': IcHome,
'ic_home_fill': IcHomeFill,
'ic_info': IcInfo,
'ic_info_fill': IcInfoFill,
'ic_insertphoto': IcInsertphoto,
'ic_krw_fill': IcKrwFill,
'ic_landmark': IcLandmark,
'ic_leisure': IcLeisure,
'ic_leisure_fill': IcLeisureFill,
'ic_list': IcList,
'ic_list_dot': IcListDot,
'ic_list_h72': IcListH72,
'ic_location': IcLocation,
'ic_location_fill': IcLocationFill,
'ic_locker_fill': IcLockerFill,
'ic_logout': IcLogout,
'ic_mail': IcMail,
'ic_map': IcMap,
'ic_maximize_fill': IcMaximizeFill,
'ic_menu': IcMenu,
'ic_menu_fill': IcMenuFill,
'ic_mic': IcMic,
'ic_minimize_fill': IcMinimizeFill,
'ic_morehoriz': IcMorehoriz,
'ic_morevert': IcMorevert,
'ic_my': IcMy,
'ic_my_fill': IcMyFill,
'ic_mylocation': IcMylocation,
'ic_nearme': IcNearme,
'ic_nearme_fill': IcNearmeFill,
'ic_nearmecircle_fill': IcNearmecircleFill,
'ic_nearmehelp': IcNearmehelp,
'ic_neutral_fill': IcNeutralFill,
'ic_neutral_fill_nomargin': IcNeutralFillNomargin,
'ic_note': IcNote,
'ic_notice': IcNotice,
'ic_notice_h32': IcNoticeH32,
'ic_notification': IcNotification,
'ic_notification_fill': IcNotificationFill,
'ic_notification_h72': IcNotificationH72,
'ic_parking': IcParking,
'ic_pause': IcPause,
'ic_pause_fill': IcPauseFill,
'ic_pause_fill_whiteshadow': IcPauseFillWhiteshadow,
'ic_phone': IcPhone,
'ic_play': IcPlay,
'ic_play_fill': IcPlayFill,
'ic_play_fill_whiteshadow': IcPlayFillWhiteshadow,
'ic_point': IcPoint,
'ic_property': IcProperty,
'ic_qr': IcQr,
'ic_refresh': IcRefresh,
'ic_registration': IcRegistration,
'ic_remove': IcRemove,
'ic_remove_fill': IcRemoveFill,
'ic_review': IcReview,
'ic_review_h72': IcReviewH72,
'ic_save': IcSave,
'ic_search': IcSearch,
'ic_search_fill': IcSearchFill,
'ic_search_h72': IcSearchH72,
'ic_seat': IcSeat,
'ic_setting': IcSetting,
'ic_share': IcShare,
'ic_smokefree': IcSmokefree,
'ic_sns_facebook': IcSnsFacebook,
'ic_sns_instagram': IcSnsInstagram,
'ic_sns_naverblog': IcSnsNaverblog,
'ic_sns_naverpost': IcSnsNaverpost,
'ic_sns_youtube': IcSnsYoutube,
'ic_sorting': IcSorting,
'ic_star': IcStar,
'ic_star_fill': IcStarFill,
'ic_subdirectory': IcSubdirectory,
'ic_subway': IcSubway,
'ic_subway_fill': IcSubwayFill,
'ic_switchairplane': IcSwitchairplane,
'ic_ticket': IcTicket,
'ic_ticket_fill': IcTicketFill,
'ic_train': IcTrain,
'ic_train_fill': IcTrainFill,
'ic_trashcan': IcTrashcan,
'ic_vacation': IcVacation,
'ic_visibilityoff': IcVisibilityoff,
'ic_visibilityon': IcVisibilityon,
'ic_volumeoff': IcVolumeoff,
'ic_volumeoff_fill': IcVolumeoffFill,
'ic_volumeoff_fill_whiteshadow': IcVolumeoffFillWhiteshadow,
'ic_volumeon': IcVolumeon,
'ic_volumeon_fill': IcVolumeonFill,
'ic_vr': IcVr,
'ic_ycoin': IcYcoin, };

export { IcAdd, IcAddFill, IcAlarm, IcAnchoringdownFill, IcAnchoringupFill, IcArea, IcArrowback, IcArrowbackFill, IcArrowdropFill, IcArrowdropFillNomargin, IcArrowforwardFill, IcArrowforwardFillNomargin, IcArrowleftFill, IcArrowleftFillNomargin, IcArrowlessFill, IcArrowmoreFill, IcArrowoneway, IcArrowrightFill, IcArrowrightFillNomargin, IcArrowroundtrip, IcArrowupFill, IcArrowupFillNomargin, IcAutorefund, IcBaggage, IcBed, IcBrandLogo, IcBus, IcBusFill, IcCalendar, IcCalendarcheck, IcCalendarcheckFill, IcCamera, IcCart, IcCartH72, IcCategory, IcCategoryFill, IcChatbot, IcChatbotH32, IcClock, IcClose, IcConvenience, IcCopy, IcCoupon, IcCouponFill, IcCouponH72, IcDayuse, IcDelete, IcDeleteFill, IcDone, IcDoneFill, IcEdit, IcEditFill, IcEnter, IcError, IcErrorFill, IcErrorH72, IcFace, IcFailoverH72, IcFaq, IcFaqH32, IcFavorite, IcFavoriteFill, IcFavoriteFillAccentshadow, IcFavoriteFillOpblack30shadow, IcFavoriteH72, IcFilter, IcFlight, IcFlightFill, IcGift, IcGiftFill, IcHelp, IcHelpFill, IcHelpdesk, IcHelpdeskH32, IcHome, IcHomeFill, IcInfo, IcInfoFill, IcInsertphoto, IcKrwFill, IcLandmark, IcLeisure, IcLeisureFill, IcList, IcListDot, IcListH72, IcLocation, IcLocationFill, IcLockerFill, IcLogout, IcMail, IcMap, IcMaximizeFill, IcMenu, IcMenuFill, IcMic, IcMinimizeFill, IcMorehoriz, IcMorevert, IcMy, IcMyFill, IcMylocation, IcNearme, IcNearmeFill, IcNearmecircleFill, IcNearmehelp, IcNeutralFill, IcNeutralFillNomargin, IcNote, IcNotice, IcNoticeH32, IcNotification, IcNotificationFill, IcNotificationH72, IcParking, IcPause, IcPauseFill, IcPauseFillWhiteshadow, IcPhone, IcPlay, IcPlayFill, IcPlayFillWhiteshadow, IcPoint, IcProperty, IcQr, IcRefresh, IcRegistration, IcRemove, IcRemoveFill, IcReview, IcReviewH72, IcSave, IcSearch, IcSearchFill, IcSearchH72, IcSeat, IcSetting, IcShare, IcSmokefree, IcSnsFacebook, IcSnsInstagram, IcSnsNaverblog, IcSnsNaverpost, IcSnsYoutube, IcSorting, IcStar, IcStarFill, IcSubdirectory, IcSubway, IcSubwayFill, IcSwitchairplane, IcTicket, IcTicketFill, IcTrain, IcTrainFill, IcTrashcan, IcVacation, IcVisibilityoff, IcVisibilityon, IcVolumeoff, IcVolumeoffFill, IcVolumeoffFillWhiteshadow, IcVolumeon, IcVolumeonFill, IcVr, IcYcoin, icons };
